webpackJsonp([197700538259302],{

/***/ 1769:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"EmailStatus","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"email","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"status","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"This is the delivery status of the email. This infomation is obtained via SendGrid.","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-email-status-2f234721eb899392e148.js